module.exports = "/_next/static/images/attorney-rodriguez-df8aa629a4f0f470cc2a397694e94547.png";